var _g, _g2, _g3, _g4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWindowsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "windows",
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.797,
    height: 11.995,
    viewBox: "0 0 12.797 11.995",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3117",
    "data-name": "Group 3117",
    transform: "translate(0 0.9)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3116",
    "data-name": "Group 3116"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12664",
    "data-name": "Path 12664",
    d: "M0,52.7v4H5.6V52Z",
    transform: "translate(0 -52)",
    fill: "#8896af"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3119",
    "data-name": "Group 3119",
    transform: "translate(6.398 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3118",
    "data-name": "Group 3118"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12665",
    "data-name": "Path 12665",
    d: "M256,16.8v4.8h6.4V16Z",
    transform: "translate(-256 -16)",
    fill: "#8896af"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3121",
    "data-name": "Group 3121",
    transform: "translate(6.398 6.398)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3120",
    "data-name": "Group 3120"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12666",
    "data-name": "Path 12666",
    d: "M256,272v4.8l6.4.8V272Z",
    transform: "translate(-256 -272)",
    fill: "#8896af"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3123",
    "data-name": "Group 3123",
    transform: "translate(0 6.398)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3122",
    "data-name": "Group 3122"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12667",
    "data-name": "Path 12667",
    d: "M0,272v4l5.6.7V272Z",
    transform: "translate(0 -272)",
    fill: "#8896af"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWindowsIcon);
export default __webpack_public_path__ + "static/media/windows-icon.4949b0461a7702e816bae871599522d6.svg";
export { ForwardRef as ReactComponent };